
import { Box, Typography } from '@mui/material'
import React from 'react'
import { SummerCampImages } from '../../assets/img/summercamp/SummerCampImages'
import Heading, { ImgText } from '../../shared/utils/Heading'
import CustomDivider from '../../shared/utils/CustomDivider'
import { DotBulletsPoints, DotBulletsWithoutPoints } from '../../shared/components/StarBulletsPoints'
import { Page_Padding } from '../../shared/constants'
import useResponsive from '../../shared/utils/Responsive'
import { getImageUrl } from '../../shared/utils/getImageUrl'

const TakeWaysForChildren = ({ takeWayData }) => {
    const points1 = ["Enhanced Creativity & Imagination", "Improved Thinking & Problem-Solving Skills"]
    const points2 = ["Better Motor Skills, Body Control & Flexibility", "Higher Self-Esteem & Positive Attitude"]
    const points3 = ["A Portfolio of Crafts, Projects & Memories", "A Fun, Happy Summer Filled With Activities They Will Cherish"]
    const points4 = ["Better Communication and Confidence", "Teamwork, Social Skills & New Friendships"]
    const isMediumScreen = useResponsive("md")
    return (

        <Box>

            <Box sx={{ position: "relative" }}>
                {
                    isMediumScreen &&
                    <Box sx={{ textAlign: "center" }} px={Page_Padding}>
                        <ImgText text={takeWayData?.heading} center />
                        <Typography variant='subtitle1' fontWeight={400} textAlign={"center"} dangerouslySetInnerHTML={{ __html: takeWayData?.subheading }} />
                    </Box>
                }

                <Box
                    component={"img"}
                    src={getImageUrl(takeWayData?.imageUrl)}
                    sx={{ width: { xs: "100%", sm: "100%", md: "90%" }, display: "block", mr: "auto", borderRadius: 0 }}

                />
                {
                    !isMediumScreen && <>

                        <Box sx={{ position: "absolute", top: "-5%", right: "5%", width: "25%", textAlign: "center" }}>
                            <ImgText text={takeWayData?.heading} center />
                            <Typography variant='subtitle1' fontWeight={400} textAlign={"center"} dangerouslySetInnerHTML={{ __html: takeWayData?.subheading }} />
                        </Box>
                        {/* <Box sx={{ position: "absolute", top: "0%", left: "20%", width: "20%" }}>
                            <DotBulletsWithoutPoints items={points1} />
                        </Box>
                        <Box sx={{ position: "absolute", top: "20%", left: "37%", width: "20%" }}>
                            <DotBulletsWithoutPoints items={points2} />
                        </Box>
                        <Box sx={{ position: "absolute", top: "40%", right: "15%", width: "20%" }}>
                            <DotBulletsWithoutPoints items={points3} />
                        </Box>
                        <Box sx={{ position: "absolute", bottom: "15%", left: "2%", width: "20%" }}>
                            <DotBulletsWithoutPoints items={points4} direction='row-reverse' />
                        </Box> */}
                    </>
                }


            </Box>
        </Box>

    )
}

export default TakeWaysForChildren
